import useAccordion, { ANIMATION_DURATION_MS } from '@components/Accordion/hooks/useAccordion';
import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import ArrowLineDown from '@icons/arrow/ArrowLineDown';
import { HTMLAttributes, ReactNode } from 'react';

interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'title'>{
    title: ReactNode;
    children?: ReactNode;
    titleClassName?: string;
    handleClassName?: string;
    initialOpen?: boolean;
}

function Accordion(props: Props) {
    const {
        title, children, titleClassName, handleClassName,
        initialOpen, ...rest
    } = props;
    const {
        ref, expand, setExpand, maxHeight, isLoad,
    } = useAccordion({ children, initialOpen });
    return (<Container aria-label='accordion' {...rest} >
        <HandleRow className={handleClassName}
            align='center'
            justify='space-between'
            onClick={() => setExpand(!expand)} >
            <Text size='lg' as='div' fontWeight='medium' className={titleClassName} >
                {title}
            </Text>
            <Arrow isExpand={expand} />
        </HandleRow>
        <Contents ref={ref} isLoad={isLoad} maxHeight={maxHeight} isExpand={expand} >
            {children}
        </Contents>
    </Container>);
}

const HandleRow = styled(Row)`
    padding: 7px 0;
`;

const Contents = styled.div<{
    isLoad: boolean,
    maxHeight?: number;
    isExpand: boolean;
}>`
    overflow: hidden;
    transition: ${({ isLoad }) => (isLoad
        ? `max-height ${ANIMATION_DURATION_MS}ms ease-in-out` : 'none')};
    max-height: ${({ isExpand, maxHeight }) => (isExpand ? maxHeight : 0)}px;
`;

const Container = styled.div`
    padding: 8px 20px 0;
    width: 100%;

    @media (prefers-reduced-motion: no-preference) {
        interpolate-size: allow-keywords;
    }
`;

const Arrow = styled(ArrowLineDown)<{
    isExpand: boolean;
}>`
    transition: transform ${ANIMATION_DURATION_MS}ms ease-in-out;
    transform: rotate(${({ isExpand }) => (isExpand ? 180 : 0)}deg);
`;

export default Accordion;
